import React from 'react';
import CV from '../../assets/Yuvraj_s_Resume.pdf';

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="btn">
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Hire me
      </a>
    </div>
  );
};

export default CTA;
